import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/marketplace/iconUpload';

// Listing icon upload (multipart). Errors are displayed inline by the
// IconUploader itself, so there is no global Error dispatch, and the
// failure payload keeps the exact message extraction the uploader
// used before the saga migration.
function* process(action) {
  const { file } = action.payload || {};
  try {
    const fd = new FormData();
    fd.append('file', file);
    // Let the browser set the multipart boundary itself.
    const headers = { ...getLocalUser() };
    delete headers['Content-Type'];
    const response = yield call(
      axios.post,
      `${config.API_URL}/marketplace/listings/icon-upload`,
      fd,
      { headers },
    );
    const url = response?.data?.data?.icon_url || response?.data?.icon_url;
    if (!url) throw new Error('No URL returned');
    yield put(fetchSuccess({ icon_url: url }));
  } catch (error) {
    yield put(fetchFailure(
      error?.response?.data?.status
      || error?.message
      || 'Icon upload failed',
    ));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
